import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../api/action/user";

const Feedback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const performLogout = () => {
    void dispatch(logout({ reason: "exam-completed" })).finally(() => {
      navigate("/", { replace: true });
    });
  };

  return (
    <div className="thank-you flex flex-col items-center justify-center" id="thank-you-container">
      <h1 className="heading" id="thank-you-heading">
        Thank You for Attending Your Interview!
      </h1>
      <p className="text" id="thank-you-message-1">
        We appreciate you taking the time to interview with us today. We were
        impressed with your qualifications and enjoyed learning more about you.
      </p>
      <p className="text" id="thank-you-message-2">
        Our team will be in touch with you within 2 business days regarding the
        next steps.
      </p>
      <button
        id="main-page-button"
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
        onClick={performLogout}
      >
        <svg
          className="mr-2 h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
        Main Page
      </button>
    </div>
  );

};

export default Feedback;
